import { useContextFallback } from '@prenuvo/halo';

import { BroadcastChannelContext } from './broadcast-channel.context';

export const useBroadcastChannel = () => useContextFallback(BroadcastChannelContext);
